import { CREATE, UPDATE } from 'react-admin'
import { RestClientMiddleware } from 'restClient/middleware/types'
import { buildHardwareDocumentApiPayload } from './apiPayload'

const COMPONENT_HARDWARE_DOCUMENT_RESOURCES = [
  'component_modules',
  'component_batteries',
  'component_inverters',
  'component_others',
] as const

export const addHardwareDocumentCapabilities: RestClientMiddleware = (requestHandler) => (type, resource, params) => {
  if (
    (type === UPDATE || type === CREATE) &&
    typeof resource === 'string' &&
    (COMPONENT_HARDWARE_DOCUMENT_RESOURCES as readonly string[]).includes(resource)
  ) {
    const hardwareDocument = params.data.hardware_document
    if (hardwareDocument && hardwareDocument.constructor === Object) {
      const nextHardwareDocument = buildHardwareDocumentApiPayload(hardwareDocument)
      if (!nextHardwareDocument) {
        const { hardware_document: _hardwareDocument, ...restData } = params.data
        return requestHandler(type, resource, {
          ...params,
          data: restData,
        })
      }
      return requestHandler(type, resource, {
        ...params,
        data: {
          ...params.data,
          hardware_document: nextHardwareDocument,
        },
      })
    }
  }

  return requestHandler(type, resource, params)
}
